import { render, staticRenderFns } from "./PageMessage.vue?vue&type=template&id=7836f166&scoped=true&"
import script from "./PageMessage.vue?vue&type=script&lang=js&"
export * from "./PageMessage.vue?vue&type=script&lang=js&"
import style0 from "./PageMessage.vue?vue&type=style&index=0&id=7836f166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836f166",
  null
  
)

export default component.exports